
$('.fake-select').click(function () {
  $(this).parent().find('ul').slideToggle()
})
if($('body').hasClass('tax-projects_cat2')) {

  let data = $('#project-data').data('current')
  $.post(
    YNA_ADMIN.ajaxUrl,
    {
      action: 'getCategories',
      data: data,
    },
    function (response) {
      $('#projects-categories').html(response)
    }
  );
}
//projects page
if($('body').hasClass('tax-projects_cat')) {

  let segId = $("#filter-projects").data('sgeid');
  $('.loading').show();
  $.post(
    YNA_ADMIN.ajaxUrl,
    {
      action: 'filterProjects',
      segId: segId,
    },
    function (response) {
      $('.loading').hide()
      $('.results-from-ajax ul').html(response)
    }
  );
}
//getProject()

$('.wrap-fake-select input').change(function () {

  getProject()
})


function getProject() {

  let segId = $("#filter-projects").data('sgeid');
  $('.results-from-ajax ul').html('')
  $('.loading').show()
  let categories = []
  $('#projects-categories li').each(function () {
    if($(this).find('input').is(":checked")){
      categories.push($(this).data('id'))
    }
  })


  let series = [];
  $('#projects-series li').each(function () {
    if($(this).find('input').is(":checked")){
      series.push($(this).data('id'))
    }
  })

  let countries = [];
  $('#projects-country li').each(function () {
    if($(this).find('input').is(":checked")){
      countries.push($(this).data('id'))
    }
  })


  $.post(
    YNA_ADMIN.ajaxUrl,
    {
      action: 'filterProjects',
      categories: categories,
      series: series,
      countries: countries,
      segId: segId,
    },
    function (response) {
      $('.paginations').hide()
      $('.loading').hide()
      $('.wrap-fake-select ul').slideUp()
      $('.results-from-ajax ul').html(response)
    }
  );
}




// WEBPACK FOOTER //
// ./scripts/routes/projects.js